import {BaseApi} from './BaseApi'

export interface PlatformAdminServiceOrderResponse {
  id: string
  orderNumber: string
  position: string
  quantity: number
  deliveryDate: Date
  department: string
  client: string // Company name
  status: string // CompanyServiceOrderStatus enum
  mspStatus: string // MspServiceOrderStatus enum
  agencyId: string
  companyId: string
  createdDate: Date
}

export interface PlatformAdminServiceOrderPagingResponse {
  data: PlatformAdminServiceOrderResponse[]
  currentPage: number
  pageSize: number
  totalPages: number
  totalCount: number
  agencyName: string
}

/**
 * Service Order API Service
 * Handles all service order related operations
 */
export class ServiceOrderApi extends BaseApi {
  /**
   * Get platform admin service orders with pagination
   * GET /api/serviceorder/getPlatformAdminServiceOrders
   */
  async getPlatformAdminServiceOrders(params?: {
    pageNumber?: number
    pageSize?: number
    sortBy?: string
    sortDirection?: 'asc' | 'desc'
    agencyId?: string
    companyId?: string
    status?: string
    mspStatus?: string
  }): Promise<PlatformAdminServiceOrderPagingResponse> {
    try {
      const queryParams = new URLSearchParams()

      if (params) {
        Object.entries(params).forEach(([key, value]) => {
          if (value !== undefined && value !== null && value !== '') {
            queryParams.append(key, value.toString())
          }
        })
      }

      const queryString = queryParams.toString()
      const url = `/api/serviceorder/getPlatformAdminServiceOrders${
        queryString ? `?${queryString}` : ''
      }`

      const response = await this.client.get<PlatformAdminServiceOrderPagingResponse>(url)
      return response.data
    } catch (error: unknown) {
      console.error('Error fetching platform admin service orders:', error)
      throw error
    }
  }
}

// Export singleton instance
export const serviceOrderApi = new ServiceOrderApi()
